import { getEditor, isEnabled } from '../composables/editorsMap';
import ImageOptions from '../menuItemComponents/ImageOptions.vue';
import { ImagePlus } from 'lucide-vue-next';
export const getImageResizerOptions = (id: string) => {
  const editor = getEditor(id)?.value;

  return {
    disabled: !isEnabled(id, 'image_resize'),
    icon: ImagePlus,
    title: 'תמונה',
    type: 'select',
    component: ImageOptions,
    props: {
      action: src => {
        const isEmptyBlock =
          editor?.state.selection.$from.parent.content.size === 0;
        let chain = editor?.chain().focus();
        if (!isEmptyBlock) chain = chain.splitBlock();

        chain.setImage({ src }).run();
      },
    },
  };
};
